import { usePostHog } from "posthog-js/react";
import { useRef } from "react";
import { useErrorModal } from "shared-ui";

import { useRemoveStatement } from "../../../queries/bank-connect/queries";

type PendingCall = { wasUnassigned: boolean; onSuccess: () => void };

export const useRemoveStatementAction = (companyDomain: string) => {
  const posthog = usePostHog();
  const { openErrorModal } = useErrorModal();
  const pendingCallRef = useRef<PendingCall | null>(null);

  const { mutate, isPending } = useRemoveStatement(companyDomain, {
    onSuccess: () => {
      const call = pendingCallRef.current;
      posthog?.capture("onboarding_bank_file_removed", { was_unassigned: call?.wasUnassigned ?? false });
      call?.onSuccess();
    },
    onError: (error) => {
      openErrorModal({ variant: "submit-error", error });
    },
  });

  const removeStatement = (uploadUuid: string, { wasUnassigned, onSuccess }: PendingCall) => {
    pendingCallRef.current = { wasUnassigned, onSuccess };
    mutate({ uploadUuid });
  };

  return { removeStatement, isPending };
};
